import create from 'zustand'
import { API } from '../../types'
import store from '../../../store'
import throwReactQueryError from '../utils/throwReactQueryError'

const API_STAGING = 'https://api.network.stg.hashtag.be/'
const API_PRODUCTION = 'https://api.network.hashtag.be/'

const BLACKLISTED_ENDPOINTS = ['/auth', '/me/password']

const E401 = async ({ error, instance }) => {
  const { getState, setState, subscribe } = create(store)

  let currentRefreshToken = undefined

  const unsubscribeRefreshToken = subscribe((state) => {
    return (currentRefreshToken = state.refreshToken)
  })

  const isStaging = getState().target === 'staging'
  const isRefreshing = getState().isRefreshingToken

  const URL = isStaging ? API_STAGING : API_PRODUCTION

  const REFRESH_URL = `${URL}auth/refresh-token`

  const requestConfig: any = error.config

  const stagingLog = (log) => {
    if (!!isStaging) {
      console.log(log)
    }
  }

  let requestQueue: any[] = []

  const isBlacklisted = BLACKLISTED_ENDPOINTS.reduce((acc, endpoint) => {
    if (requestConfig?.url?.includes(endpoint)) {
      return true
    }

    return acc
  }, false)

  if (!isRefreshing && !isBlacklisted) {
    setState({ isRefreshingToken: true })

    stagingLog('User token expired, pausing requests until it`s valid again')

    instance
      .post(REFRESH_URL, { refreshToken: currentRefreshToken })
      .then((response: API.RefreshTokenResponse) => {
        const { token, refreshToken } = response?.data?.data
        getState().setTokens({ token, refreshToken })

        instance.defaults.headers['Authorization'] = `Bearer ${token}`

        if (!!token) {
          stagingLog('New user token received, resuming requests')
        }

        requestQueue.forEach((request) => request.onSuccess(token))
        requestQueue = []
      })
      .catch((err: any) => {
        requestQueue.forEach((request) => request.onFailure(err))
        requestQueue = []

        getState().flush()
      })
      .finally(() => {
        unsubscribeRefreshToken()
        setState({ isRefreshingToken: false })
      })

    return new Promise((resolve, reject) => {
      setState({ isRefreshingToken: false })

      requestQueue.push({
        onSuccess: (token: string) => {
          requestConfig.headers['Authorization'] = `Bearer ${token}`

          resolve(instance(requestConfig))
        },
        onFailure: (err: any) => reject(err)
      })
    })
  }

  if (!!isRefreshing && !isBlacklisted) {
    stagingLog(
      'Another interceptor is currently refreshing the token, hang tight'
    )

    return new Promise((resolve) => resolve(true))
  }

  if (!!isBlacklisted) {
    // reset token refresh state as a fallback for stuck requests
    setState({ isRefreshingToken: false })

    unsubscribeRefreshToken()

    stagingLog(
      `Endpoint "${requestConfig?.url}" is blacklisted, skipping error 401 interceptor`
    )

    return throwReactQueryError(error)
  }
}

export default E401
